import styled, { css } from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'
import { rgba } from 'polished'
import { BREAKPOINTS } from '@at/window-utils/lib/responsive-utils/match-media.util'

export const StyledErrorBoxContainer = styled.div`
    ${({ theme }) => {
        return css`
            & h3,
            & h2,
            & h1 {
                color: ${theme.color.text.title};
                margin: 0 0 ${ThemeSelectors.getGroupFourSpacing(theme)} 0;
                font-size: 21px;
            }
            & p {
                color: ${theme.color.text.default};
                font-size: 14px;
                margin: 0 0 ${ThemeSelectors.getGroupFourSpacing(theme)} 0;
            }
            & button {
                @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
                    width: auto;
                }
                margin: ${ThemeSelectors.getGroupTwoSpacing(theme)} 0 0;
                width: 100%;
            }
            @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
                margin: ${ThemeSelectors.getGroupFourSpacing(theme)} auto;
                padding: ${ThemeSelectors.getGroupSixSpacing(theme)};
            }
            @keyframes zeroResults {
                0% {
                    opacity: 0;
                }
                100% {
                    opacity: 1;
                }
            }
            margin: 0 auto;
            padding: ${ThemeSelectors.getGroupFiveSpacing(theme)};
            background-color: ${rgba(theme.color.bg.soft, 0.5)};
            border-radius: 4px;
            opacity: 0;
            animation: zeroResults 0.2s 1;
            animation-fill-mode: forwards;
            width: 80%;
            text-align: center;
        `
    }}
`
